var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10C17.5 5.86064 14.1394 2.5 10 2.5C5.86064 2.5 2.5 5.86064 2.5 10C2.5 14.1394 5.86064 17.5 10 17.5C14.1394 17.5 17.5 14.1394 17.5 10V10M0 10C0 4.48085 4.48085 0 10 0C15.5192 0 20 4.48085 20 10C20 15.5192 15.5192 20 10 20C4.48085 20 0 15.5192 0 10V10M10 13.125C11.7247 13.125 13.125 11.7247 13.125 10C13.125 8.27527 11.7247 6.875 10 6.875C8.27527 6.875 6.875 8.27527 6.875 10C6.875 11.7247 8.27527 13.125 10 13.125V13.125M10 4.375C13.1045 4.375 15.625 6.89548 15.625 10C15.625 13.1045 13.1045 15.625 10 15.625C6.89548 15.625 4.375 13.1045 4.375 10C4.375 6.89548 6.89548 4.375 10 4.375V4.375M8.75 10C8.75 9.31011 9.31011 8.75 10 8.75C10.6899 8.75 11.25 9.31011 11.25 10C11.25 10.6899 10.6899 11.25 10 11.25C9.31011 11.25 8.75 10.6899 8.75 10V10",
    fill: "#054254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetIcon);
export default __webpack_public_path__ + "static/media/targetIcon.2a5116eebe788233cd0bdad68ec68d54.svg";
export { ForwardRef as ReactComponent };